import styled from 'styled-components';

export const Header1Text = styled.div`
  ${(props) => props.theme.fonts.mixins.header1}
`;

export const BoldHeader1Text = styled.div`
  ${(props) => props.theme.fonts.mixins.boldHeader1}
`;

export const Header2Text = styled.div`
  ${(props) => props.theme.fonts.mixins.header2}
`;

export const BoldHeader2Text = styled.div`
  ${(props) => props.theme.fonts.mixins.boldHeader2}
`;

export const Header3Text = styled.div`
  ${(props) => props.theme.fonts.mixins.header3}
`;

export const BoldHeader3Text = styled.div`
  ${(props) => props.theme.fonts.mixins.boldHeader3}
`;

export const Header4Text = styled.div`
  ${(props) => props.theme.fonts.mixins.header4}
`;

export const BoldHeader4Text = styled.div`
  ${(props) => props.theme.fonts.mixins.boldHeader4}
`;

export const Header5Text = styled.div`
  ${(props) => props.theme.fonts.mixins.header5}
`;

export const BoldHeader5Text = styled.div`
  ${(props) => props.theme.fonts.mixins.boldHeader5}
`;

export const ButtonText = styled.div`
  ${(props) => props.theme.fonts.mixins.button}
`;

export const BoldButtonText = styled.div`
  ${(props) => props.theme.fonts.mixins.boldButton}
`;

export const SmallButtonText = styled.div`
  ${(props) => props.theme.fonts.mixins.smallButton}
`;

export const BoldSmallButtonText = styled.div`
  ${(props) => props.theme.fonts.mixins.boldSmallButton}
`;

export const BodyText = styled.div`
  ${(props) => props.theme.fonts.mixins.body}
`;

export const BoldBodyText = styled.div`
  ${(props) => props.theme.fonts.mixins.boldBody}
`;

export const SmallBodyText = styled.div<{ intent?: 'faded' | 'bold' | 'italic' }>`
  ${({ theme, intent }) => (intent === 'bold' ? theme.fonts.mixins.boldSmall : theme.fonts.mixins.small)}
  ${({ theme, intent }) => (intent === 'faded' ? `color: ${theme.colors.darkGray};` : '')}
  ${({ intent }) => (intent === 'italic' ? `font-style: italic;` : '')}
`;

export const SmallBodyTextNoWrap = styled(SmallBodyText)`
  white-space: nowrap;
`;

export const BoldSmallBodyText = styled.div`
  ${(props) => props.theme.fonts.mixins.boldSmall}
`;

export const TinyBodyText = styled.div`
  ${(props) => props.theme.fonts.mixins.tiny}
`;

export const BoldTinyBodyText = styled.div`
  ${(props) => props.theme.fonts.mixins.boldTiny}
`;

export const EyebrowText = styled.div`
  ${(props) => props.theme.fonts.mixins.eyebrow}
`;

export const BoldEyebrowText = styled.div`
  ${(props) => props.theme.fonts.mixins.boldEyebrow}
`;

export const DangerText = styled.div`
  color: ${(props) => props.theme.colors.errorDark};
`;
